<template>
  <AppSection
    id="cron-config"
    type="section"
    :title="$t($getConst.pages.cron_config.cron_config_page_title)"
    :is-section-loading="isLoading"
  >

    <b-row class="justify-content-center py-5">

      <template v-if="!isLoading && getAlertCronConfig">
        <b-col xl="3" lg="4" md="4" sm="6" class="pb-4">
            <AppPageOptionBox
              @onClick="openCronDetails(getAlertCronConfig.id, getAlertCronConfig.cron_name)" :text="getAlertCronConfig.cron_name" :icon="$getConst.svgIcons.get_alert"/>
        </b-col>
      </template>

      <template v-if="!isLoading && messageSentCronConfig">
        <b-col xl="3" lg="4" md="4" sm="6" class="pb-4">
            <AppPageOptionBox
              @onClick="openCronDetails(messageSentCronConfig.id, messageSentCronConfig.cron_name)" :text="messageSentCronConfig.cron_name" :icon="$getConst.svgIcons.message_sent"/>
        </b-col>
      </template>

    </b-row>

  </AppSection>
</template>

<script>
  import AppSection from "../../../../components/common/sections/AppSection";
  import AppPageOptionBox from "../../../../components/common/utils/AppPageOptionBox";
  import AppSpinner from "../../../../components/common/utils/AppSpinner";
  import AppSuccessCheckAnimation from "../../../../components/common/utils/AppSuccessCheckAnimation";
  import AppErrorAnimation from "../../../../components/common/utils/AppErrorAnimation";
  import {getCronConfig} from "../../../../api/scopes.api";

  export default {
    name: "CronList",
    components: {AppErrorAnimation, AppSuccessCheckAnimation, AppSpinner, AppPageOptionBox, AppSection},
    props: ['scope_id'],
    data() {
      return {
        getAlertCronConfig: null,
        messageSentCronConfig: null,
        options: [],
        isLoading: false
      }
    },
    methods: {
      getCronConfigData() {
        this.isLoading = true;
        getCronConfig(this.scope_id).then(
          (response) => {
            this.getAlertCronConfig = response.data.find(cron => cron.cron_name === "Get Alert");
            this.messageSentCronConfig = response.data.find(cron => cron.cron_name === "Message Sent");
            this.isLoading = false;
          },
          (error) => {
            this.handleApiError(error);
            this.isLoading = false;
          }
        )
      },
      openCronDetails(cron_id, cron_name) {
        this.$router.push({name: this.$getConst.routesNames.administration.editCronConfig, params: {cron_id, cron_name}});
      }
    },
    created() {
      this.getCronConfigData()
    },
  }
</script>

<style scoped>

</style>
